export const UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE = 'UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE';

export const updateStatementTemplatePlaceholderFailure = error => ({
    type: UPDATE_STATEMENT_TEMPLATE_PLACEHOLDER_FAILURE,
    payload: error,
    error: true,
});
